import { useContext } from 'react';
import { SelectedProductContext } from 'src/products/productsSummary/SelectedProductContext';

export const useSelectedProduct = () => {
  return useContext(SelectedProductContext);
};
